<template>
    <div class="union-selector" :class="['theme' + theme,{'drop': isDrop}]">
        <div class="mask" v-if="isDrop" @click="isDrop=false"></div>
        <span class="slct-title" @click="switchDrop">{{selectedTitle}}</span>
        <transition name="slide-vertical30-quick">
            <ul class="slct-drop" v-if="isDrop">
                <li class="slct-drop-item" v-for="item in options" :key="item[optionValName]" 
                :class="{'selected': item.selected}" @click="changeOption(item)">{{item[optionKeyName]}}</li>
            </ul>
        </transition>
    </div>
</template>
<script>
    export default {
        props: {
            options: { //选项列表
                type: Array,
                default: [
                    // {
                    //     key: "上午",
                    //     val: "上午",
                    //     selected: false,
                    // },
                ]
            },
            optionValName: { //选项值字段名称
                type: String,
                default: "val"
            },
            optionKeyName: { //选项名字段名称
                type: String,
                default: "key"
            },
            isMultiple: { //是否多选
                type: Boolean,
                default: false
            },
            isDefaultSelected: { //是否指定默认选中项，默认第一项
                type: Boolean,
                default: true
            },
            defaultPlaceholder: { //默认提示文案 - 不指定默认选中项时
                type: String|Number,
                default: "请选择"
            },
            theme: { //主题风格
                type: String|Number,
                default: 0
            },
        },
        data(){
            return {
                selectedTitle: "", //选中项标题 - 仅一个选项，若是多选并有多个选中项，则默认第一个
                isDrop: false, //是否下拉
            }
        },
        mounted(){
            this.init();
        },
        methods:{
            //初始化默认选中项
            init(){
                let self = this;
                let isSelected = false;
                //遍历是否有选中项，如果有，则显示已选中项key
                for(let i=0; i<self.options.length; i++){
                    if(self.options[i].selected){
                        isSelected = true;
                        self.selectedTitle = "";
                        self.selectedTitle = self.options[i][self.optionKeyName];
                        break;
                    } else {
                        self.options[i].selected = false;
                    }
                }
                //如果没有已选中项
                if(!isSelected){
                    if(!self.isDefaultSelected){ //如果不指定默认选中，则显示默认提示文案
                        self.selectedTitle = "";
                        self.selectedTitle = self.defaultPlaceholder;
                    } else { //如果指定默认，则默认第一个，并触发父组件初始化默认选中行为
                        self.options[0].selected = true;
                        self.selectedTitle = self.options[0][self.optionKeyName];
                        self.$emit("selectResult");
                    }
                }
            },
            //下拉开关
            switchDrop(){
                this.isDrop = !this.isDrop;
            },
            //选项选择
            changeOption(item){
                let self = this;
                //如果是单选，先把所有选项置为非选状态
                if(!self.isMultiple){
                    self.options.map(option => {
                        option.selected = false;
                    });
                }
                item.selected = !item.selected;
                //设置选中项标题
                let isSelected = false;
                for(let i=0; i<self.options.length; i++){
                    if(self.options[i].selected){
                        isSelected = true;
                        self.selectedTitle = "";
                        self.selectedTitle = self.options[i][self.optionKeyName];
                        break;
                    }
                }
                if(!isSelected){
                    self.selectedTitle = "";
                    self.selectedTitle = self.defaultPlaceholder;
                }
                //把选择结果提交给父组件
                self.$emit("selectResult");
                //如果是单选，则关闭下拉
                if(!self.isMultiple){
                    self.isDrop = false;
                }
            },
        }
    }
</script>
<style src="./selector.css"></style>



// WEBPACK FOOTER //
// src/shared/components/selector.vue